module.exports = __webpack_public_path__ + "fonts/Mulish-Italic.3e6c2d08.ttf";